/* eslint-disable import/prefer-default-export */

export const setQueryStringParameter = ({
  name,
  value,
  append = false,
}: {
  name: string;
  value: string;
  append: boolean;
}) => {
  const url = new URL(window.document.URL);
  // Delete name to avoid duplicate entries
  url.searchParams.delete(name);
  if (append) url.searchParams.append(name, value);
  else url.searchParams.set(name, value);
  window.history.replaceState(null, '', url.toString());
};
